import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import { ProfilePrivacyStatus } from '../../../types';
import { accountDataThunk } from '../../thunks/accountData';
import { updateLoginEmail } from '../../thunks/loginInfo';
import type { State } from './slice';
import {
  makeProfilePrivate,
  makeProfilePublic,
  unblockMember,
  updateSlug,
} from './thunk';

export const extraReducers = (builder: ActionReducerMapBuilder<State>) => {
  builder
    .addCase(makeProfilePrivate.fulfilled, (state) => {
      state.privacyStatus = ProfilePrivacyStatus.PRIVATE;
    })
    .addCase(makeProfilePublic.fulfilled, (state) => {
      state.privacyStatus = ProfilePrivacyStatus.PUBLIC;
    })
    .addCase(updateSlug.fulfilled, (state, { payload }) => {
      state.profile.slug = payload.newSlug;
    })
    .addCase(unblockMember.fulfilled, (state, { payload }) => {
      state.blockedMembers = state.blockedMembers?.filter(
        (member) => member.id !== payload.id,
      );
    })
    .addCase(updateLoginEmail.fulfilled, (state, { payload }) => {
      if (payload.stage === 'ok' && payload.newEmail) {
        state.loginEmail = payload.newEmail;
      }
    })
    .addCase(
      accountDataThunk.updateAccountData.fulfilled,
      (state, { payload }) => {
        if (state.profile.photo?.url !== payload.member.profile.photo?.url) {
          state.profile.photo = payload.member.profile.photo;
        }
      },
    );
};
